/**
 * Local store
 * @module store/local
 */

import { createStore, createHook } from '@thermon-platforms/react-sweet-state';


// define store initial state
const initialState = {
  lastSawLicenseInterrupt: JSON.parse(localStorage.getItem('lastSawLicenseInterrupt')) || undefined,
};
// define the actions that mutate the state
export const actions = {
  setLastSawLicenseInterrupt: (timestamp) => ({ setState }) => {
    localStorage.setItem('lastSawLicenseInterrupt', JSON.stringify(timestamp));
    setState({ lastSawLicenseInterrupt: timestamp });
  }
}

// create a store type
const Store = createStore({ initialState, actions });

// create components to access store state instances
const useStore = createHook(Store);

/**
 * Expose hooks for store
 * @function useStore
 * @memberof module:store/local
 *
 * @example
 * const [localStore, localStoreActions] = useLocalStore();
 *
 */
export default useStore;
